import { getLocale } from "../runtime";

const da_easteregg1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tag et øjeblik til at trække vejret dybt. Selv omveje kan være en del af rejsen.`
};

const en_easteregg1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Take this moment to breathe deeply. Even detours can be part of the journey.`
};

const es_easteregg1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tómate un momento para respirar profundamente. Incluso los desvíos pueden ser parte del viaje.`
};

const fi_easteregg1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ota hetki aikaa hengittää syvään. Myös kiertotiet voivat olla osa matkaa.`
};

const nb_easteregg1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ta et øyeblikk for å puste dypt. Selv omveier kan være en del av reisen.`
};

const sv_easteregg1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ta en stund att andas djupt. Även omvägar kan vara en del av resan.`
};

const easteregg1 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_easteregg1(inputs)
	if (locale === "en") return en_easteregg1(inputs)
	if (locale === "es") return es_easteregg1(inputs)
	if (locale === "fi") return fi_easteregg1(inputs)
	if (locale === "nb") return nb_easteregg1(inputs)
	if (locale === "sv") return sv_easteregg1(inputs)
	return "easterEgg1";
};

export { easteregg1 as "easterEgg1" };